import {
    Avatar,
    AvatarGroup,
    Box,
    Button,
    Card,
    CardHeader,
    Chip,
    FormControl,
    InputLabel,
    Menu,
    MenuItem,
    Pagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Grid, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
    confirmOrder,
    deleteOrder,
    deliveredOrder,
    getOrders,
    shipOrder,
} from "../../../Redux/Admin/Orders/Action";

const PendingOrdersPage = () => {
    const navigate = useNavigate();
    const [anchorElArray, setAnchorElArray] = useState([]);
    const dispatch = useDispatch();
    const jwt = localStorage.getItem("jwt");
    const { adminsOrder } = useSelector((store) => store);

    useEffect(() => {
        dispatch(getOrders({ jwt }));
    }, [jwt, adminsOrder.delivered, adminsOrder.shipped, adminsOrder.confirmed]);

    const handleUpdateStatusMenuClick = (event, index) => {
        const newAnchorElArray = [...anchorElArray];
        newAnchorElArray[index] = event.currentTarget;
        setAnchorElArray(newAnchorElArray);
    };

    const handleUpdateStatusMenuClose = (index) => {
        const newAnchorElArray = [...anchorElArray];
        newAnchorElArray[index] = null;
        setAnchorElArray(newAnchorElArray);
    };

    const handleConfirmedOrder = (orderId, index, currentStatus) => {
        if (currentStatus === "PENDING") {
            handleUpdateStatusMenuClose(index);
            dispatch(confirmOrder(orderId));
        }
    };

    const handleDeleteOrder = (orderId) => {
        handleUpdateStatusMenuClose();
        dispatch(deleteOrder(orderId));
    };

    const pendingOrders = adminsOrder?.orders?.filter(
        (order) => order.orderStatus === "PENDING"
    );

    return (
        <Box>
            <Card className="mt-2">
                <CardHeader
                    title="Pending Orders"
                    sx={{
                        pt: 2,
                        alignItems: "center",
                        "& .MuiCardHeader-action": { mt: 0.6 },
                    }}
                />
                <TableContainer>
                    <Table sx={{ minWidth: 800 }} aria-label="table in dashboard">
                        <TableHead>
                            <TableRow>
                                <TableCell>Image</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Id</TableCell>
                                <TableCell sx={{ textAlign: "center" }}>Status</TableCell>
                                <TableCell sx={{ textAlign: "center" }}>Update</TableCell>
                                <TableCell sx={{ textAlign: "center" }}>Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pendingOrders?.map((item, index) => (
                                <TableRow
                                    hover
                                    key={item.name}
                                    sx={{ "&:last-of-type td, &:last-of-type th": { border: 0 } }}
                                >
                                    <TableCell>
                                        <AvatarGroup max={4} sx={{ justifyContent: "start" }}>
                                            {item.orderItems.map((orderItem) => (
                                                <Avatar
                                                    alt={item.title}
                                                    src={orderItem.product?.imageUrl}
                                                />
                                            ))}
                                        </AvatarGroup>
                                    </TableCell>

                                    <TableCell
                                        sx={{ py: (theme) => `${theme.spacing(0.5)} !important` }}
                                        onClick={() => navigate(`/admin/orders/${item._id}`)}
                                    >
                                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                                            <Typography
                                                sx={{
                                                    fontWeight: 500,
                                                    fontSize: "0.875rem !important",
                                                }}
                                            >
                                                {item?.orderItems.map((order) => (
                                                    <span className=""> {order.product?.title},</span>
                                                ))}
                                            </Typography>
                                            <Typography variant="caption">
                                                {item?.orderItems.map((order) => (
                                                    <span className="opacity-60">
                                                        {order.product?.brand},
                                                    </span>
                                                ))}
                                            </Typography>
                                        </Box>
                                    </TableCell>

                                    <TableCell>{item?.totalPrice}</TableCell>
                                    <TableCell>{item?._id}</TableCell>
                                    <TableCell>
                                        <Chip
                                            sx={{
                                                color: "white !important",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}
                                            label={item?.orderStatus}
                                            size="small"
                                            color="info"
                                            className="text-white"
                                        />
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>
                                        <Button
                                            aria-controls={`basic-menu-${item._id}`}
                                            aria-haspopup="true"
                                            aria-expanded={Boolean(anchorElArray[index])}
                                            onClick={(event) =>
                                                handleUpdateStatusMenuClick(event, index)
                                            }
                                        >
                                            Status
                                        </Button>
                                        <Menu
                                            id={`basic-menu-${item._id}`}
                                            anchorEl={anchorElArray[index]}
                                            open={Boolean(anchorElArray[index])}
                                            onClose={() => handleUpdateStatusMenuClose(index)}
                                        >
                                            <MenuItem
                                                onClick={() =>
                                                    handleConfirmedOrder(
                                                        item._id,
                                                        index,
                                                        item.orderStatus
                                                    )
                                                }
                                            >
                                                CONFIRMED ORDER
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "center" }}>
                                        <Button
                                            onClick={() => handleDeleteOrder(item._id)}
                                            variant="text"
                                        >
                                            delete
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>
            <Card className="mt-2 flex justify-center items-center">
                <Pagination
                    className="py-5 w-auto"
                    size="large"
                    count={Math.ceil(pendingOrders?.length / 10)} // Assuming 10 items per page
                    color="primary"
                />
            </Card>
        </Box>
    );
};

export default PendingOrdersPage;
